import { render } from "./IconAttachMoney.vue?vue&type=template&id=8c0ac7fe"
import script from "./IconAttachMoney.vue?vue&type=script&lang=js"
export * from "./IconAttachMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__